import { msg } from '@lingui/macro';
import { IconUsersGroup } from '@tabler/icons-react';
import type { ImporterDescriptor } from '../../../descriptors/types';

const descriptor: ImporterDescriptor = {
  id: 'partnerAliasImport',
  status: 'active',
  category: 'master-list',
  icon: IconUsersGroup,
  title: msg`Partner aliases`,
  shortTitle: msg`Partner aliases`,
  whenToUse: msg`Import aliases for your partners so producer and supplier names match automatically across data sources.`,
  outputDescription: msg`Saves alternate-name aliases against existing partners for automated matching.`,
  intents: [
    'Auto-match producer names',
    'Import partner aliases',
    'Resolve naming differences between systems',
    'Train alias matching for suppliers',
  ],
  keywords: [
    'alias',
    'partner',
    'producer',
    'supplier',
    'match',
    'auto-match',
    'name',
    'company',
  ],
  synonyms: ['name variants', 'aka', 'also known as'],
  inputHints: {
    fileTypes: ['xlsx'],
    sampleHeaders: ['Partner name', 'Alias'],
    requiredColumns: ['Partner name', 'Alias'],
  },
};

export default descriptor;
